import useFeaturePermissions from './useFeaturePermissions.ts';
import { Permissions } from '@auth/permissions.ts';

/**
 * Get the permission of the entity quantity unit
 * @param organizationId
 * @returns An object containing the write and read permissions
 */
export const useQuantityUnitsPermissions = (organizationId: string) => {
  const { writePermission, readPermission } = useFeaturePermissions(organizationId, Permissions.QuantityUnitsChange, Permissions.QuantityUnitsRead);
  return { writePermission, readPermission };
};
